import Input from '../../../components/Input';
import List from '../../../components/List';
import Button from '../../../components/Button';
import Description from '../../../components/Description';
import { postBrokerProductSecret } from '../../../../../../services/integrationResources';
import Notification from '../../../../../Utils/Notification';
import { useIntl } from 'react-intl';
import { Fragment, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectUserInfo } from '../../../../../../store/selectors';
import { useLocation } from 'react-router-dom';

const PermissionsProductionVerification = ({ onCallBack }) => {
  const [secret, setSecret] = useState(null);
  const [formError, setFormError] = useState([]);

  const [verifyButtonStatus, setVerifyButtonStatus] = useState(true);
  const { formatMessage } = useIntl();
  const {
    data: { recommendationCode },
  } = useSelector(selectUserInfo);

  const { search } = useLocation();
  const useQuery = () => new URLSearchParams(search);
  const query = useQuery();
  const product = query.get('product');

  const handleVerification = useCallback(async () => {
    if (!secret) {
      return;
    }

    await postBrokerProductSecret(recommendationCode, product, secret)
      .then(async (response) => {
        onCallBack(true, response.data);

        Notification({
          type: 'success',
          text: formatMessage({ id: 'Success' }),
        }).show();
      })
      .catch((error) => {
        onCallBack(false);
        setFormError(error?.response?.data?.errors);

        Notification({
          type: 'error',
          text: formatMessage({
            id: 'Something went wrong, try again later',
          }),
        }).show();
      });
  }, [secret]);

  const handlePassword = useCallback((response) => {
    setFormError([]);
    setSecret(response.target.value);
    response.target.value.length > 4 ? setVerifyButtonStatus(false) : setVerifyButtonStatus(true);
  }, []);

  return (
    <Fragment>
      <Description message='Integration production form access message' />

      <List direction='column'>
        <div style={{ width: '320px' }}>
          <Input
            type='password'
            label='Integration form production password'
            placeholder='Podaj swoje hasło do Strefy Partnera'
            onChange={handlePassword}
          />
        </div>
      </List>

      {formError && formError.length > 0 && (
        <List direction='column'>
          {formError?.map((error, index) => (
            <div key={index} style={{ margin: '0 0 5px' }}>
              <span style={{ color: 'red' }}>{error}</span>
            </div>
          ))}
        </List>
      )}

      <Button label='Verify' onCallback={handleVerification} isDisabled={verifyButtonStatus} />
    </Fragment>
  );
};

export default PermissionsProductionVerification;
